import React from 'react';
import { cn } from '@/lib/utils';

interface MessageBubbleProps {
  children: React.ReactNode;
  isUser?: boolean;
  className?: string;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({
  children,
  isUser = false,
  className = ''
}) => {
  if (isUser) {
    return (
      <div className={cn('flex justify-end text-left', className)}>
        <div className="relative rounded-lg bg-gray-100 px-2 py-1 text-left">
          {/* 用户消息的小三角 - 右上方 */}
          {/* <div className="absolute -top-1 right-5 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-gray-100"></div> */}
          <span className="text-left text-sm text-gray-900">{children}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex justify-start text-left', className)}>
      <div className="relative rounded-lg bg-blue-50 px-2 py-1 text-left">
        {/* AI消息的小三角 - 左上方 */}
        <div className="absolute -top-1 left-5 h-0 w-0 border-b-[6px] border-l-[6px] border-r-[6px] border-b-blue-50 border-l-transparent border-r-transparent"></div>
        <span className="text-left text-sm text-gray-900">{children}</span>
      </div>
    </div>
  );
};

export default MessageBubble;
